import axios from "axios";

export const fetchActiveItems = async () => {
    console.log("Fetching active items...");
    const response = await axios.get(`/api/instructions/getActiveItems`);
   
    return response.data;
  };
  